module.exports = __webpack_public_path__ + "static/media/logo-yellow.4b15b5ef.svg";